//NPM Packages
import { React, useContext } from "react";
import styled from "styled-components";

//Context
import MyContext from "../context/MyContext";

//Components
import Authentication from "../components/Shared/Authentication";
import Insurance from "../components/DemoVehicleInsurance/Insurance";
import Insured from "../components/DemoVehicleInsurance/Insured";
import Address from "../components/DemoVehicleInsurance/Address";
import Vehicles from "../components/DemoVehicleInsurance/Vehicles";

import Header from "../components/Shared/Header";
import { Wrapper } from "../components/styles/Wrapper.styled";

const FormWrapper = styled.div`
  padding: ${(props) => props.theme.space[1]};

  @media ${({ theme }) => theme.device.mobileL} {
    padding: ${(props) => props.theme.space[2]};
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding: ${(props) => props.theme.space[3]};
  }
`;

function DemoVehicleInurance(props) {
  const {
    //Authentication
    idVerification,
    idVerificationRequired,

    //Forms
    insuranceDataCaptured,
    insuredDataCaptured,
    addressDataCaptured,
  } = useContext(MyContext);

  return (
    <Wrapper>
      <Header
        name="Laminin Vehicle Insurance Demo"
        description="Laminin Vehicle Insurance Demo"
        logoPath="../images/laminin-demo-white-bg.png"
      />

      {!idVerification && idVerificationRequired && <Authentication />}

      {(idVerification || !idVerificationRequired) && (
        <FormWrapper>
          {!insuredDataCaptured && (
            <Insured name="Laminin" formName="Vehicle Insurance Demo" />
          )}

          {!addressDataCaptured && insuredDataCaptured && (
            <Address name="Laminin" formName="Vehicle Insurance Demo" />
          )}

          {!insuranceDataCaptured &&
            addressDataCaptured &&
            insuredDataCaptured && (
              <Insurance name="Laminin" formName="Vehicle Insurance Demo" />
            )}

          {insuranceDataCaptured &&
            addressDataCaptured &&
            insuredDataCaptured && (
              <Vehicles name="Laminin" formName="Vehicle Insurance Demo" />
            )}
        </FormWrapper>
      )}
    </Wrapper>
  );
}

export default DemoVehicleInurance;
